<template>
  <Modal position="end" ref="modalDialogRef">
    <template #header>{{ headerTitle }}</template>
    <template #body>
      <View direction="column" gap="md">
        <Chips>
          <Chip v-for="tab of tabs" :key="tab" :is-active="tab === activeTab" @click="setActiveTab(tab)">
            {{ tab }}
          </Chip>
        </Chips>

        <Text variant="body-medium" color="secondary">
          {{ activeTab === PortfolioPerformanceTabs.Cold ? 'Underperforming' : 'Top-performing' }} properties
          <b>in the last 7 days</b>
        </Text>

        <View v-if="isPending.value" justify="center">
          <LoadingIndicator />
        </View>

        <Text v-else-if="data.length === 0" variant="body-medium" align="center" color="tertiary">No data yet</Text>

        <PortfolioPerformanceList v-else :items="data" />
      </View>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Chip, Chips, LoadingIndicator, Modal, Text, View } from '@tallo/design-system';

import { useUnitPerformanceComposable } from '../composables/unit-performance.composable';
import { PortfolioPerformanceTabs } from '../enums/portfolio-performance-tabs.enum';
import PortfolioPerformanceList from './portfolio-performance-list.vue';

const tabs = Object.values(PortfolioPerformanceTabs);

const modalDialogRef = ref<InstanceType<typeof Modal>>();
const { activeTab, isPending, data, setActiveTab } = useUnitPerformanceComposable();

const headerTitle = computed(() => activeTab.value);

function open(tab: PortfolioPerformanceTabs) {
  setActiveTab(tab);
  modalDialogRef.value?.show();
}

defineExpose({ open });
</script>

<style scoped lang="scss"></style>
